<div class="user-card">
  <!-- Bajo el breakpoint: solo el avatar con iniciales; el detalle va en el tooltip. -->
  <div
    class="user-card__avatar"
    [attr.aria-label]="tooltipText()"
    [matTooltip]="tooltipText()"
    matTooltipPosition="below"
  >
    {{ initials() }}
  </div>

  <!-- Desde el breakpoint: diseño completo original, sin el avatar. -->
  <div class="user-card__full flex items-center">
    <div class="flex flex-col">
      <h3 class="flex items-center gap-2">
        <mat-icon>person</mat-icon> {{ user()?.firstName | titlecase }} {{ user()?.lastName | titlecase }}
      </h3>
      <p class="flex items-center gap-2">
        <mat-icon>business</mat-icon> {{ business()?.name }}
      </p>
    </div>
    @if (logoUrl()) {
      <hr>
      <div class="user-card__logo">
        <img [src]="logoUrl()" alt="Logo de la empresa">
      </div>
    }
  </div>
</div>